import { CordeliaShortLogo } from "../../assets/svg";
import "./FullPageLoader.scss";

const FullPageLoader: React.FC = () => {
  
  return (
    <div className="full-page-loader-wrapper">
          <div>
            <div></div>
           <CordeliaShortLogo/>
        </div>
    </div>
  );
};

export default FullPageLoader;
